const capitalizeFirstLetter = (word) => {
    if (!word) return ''

    const result = word.charAt(0).toUpperCase() + word.slice(1)
    return result
}

const convertParamCaseToCamelCase = (parameterName) => {
    const parts = parameterName.split('-')

    let result = ''
    for (let i = 0; i < parts.length; i++) {
        if (i === 0) {
        result = result + parts[i]
        } else {
        result = result + capitalizeFirstLetter(parts[i])
        }
    }

    return result
}

const parseParameter = (parameterValue) => {
    try {
        return Function('"use strict"; return (' + parameterValue + ')')()
    } catch {
        return parameterValue
    }
}

export const getInitialParameters = (parameters, props, mappers) => {
    let result = { ...parameters }

    for (const key in props) {
        const parameterKey = convertParamCaseToCamelCase(key)
        if (parameters.hasOwnProperty(parameterKey) && props.hasOwnProperty(key)) {
        const value = parseParameter(props[key])
        const finalValue = mappers.hasOwnProperty(parameterKey)
            ? mappers[parameterKey](value)
            : value
        result[parameterKey] = finalValue
        }
    }

    return result
}
